export default __webpack_public_path__ + "static/4-1d686c1cb57739d44bdd16f219eb8852.jpeg";